import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%",
    height: "100%",
    minWidth: "fit-content",
    gap: 3,
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
      width: "100%",
      minWidth: "unset",
      maxWidth: "100%",
      overflowX: "hidden",
    },
  },
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    minHeight: "100%",
    height: "75vh",
    gap: 2,
    width: "100%",
    flexGrow: 1,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      minWidth: "unset",
      maxWidth: "100%",
      boxSizing: "border-box",
      overflowX: "hidden",
    },
    overflowY: "auto",
  },
  boxHeaderCards: {
    width: "100%",
    height: "50px",
    display: "flex",
    flexDirection: "row",
    paddingLeft: 4,
    gap: 6,
    alignItems: "center",
    borderTop: "1px solid " + theme.palette.color.stroke,
    borderBottom: "1px solid " + theme.palette.color.stroke,
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 1,
    },
  },
  boxSearchAndButton: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: 1,
      alignItems: "stretch",
    },
  },
  buttonBox: {
    display: "flex",
    justifyContent: "space-between",
    width: "33%",
    gap: 1,
  },
  button: {
    height: "40px",
    flex: 1,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  searchInput: {
    width: "67%",
    flex: 1,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  textHeader: { color: theme.palette.text.secondary },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "100%",
  },
  buttonMobile: {
    width: "100%",
    maxHeight: "40.78px",
    p: 1.3,
    minWidth: 0,
  },
  buttonMobileOutlined: {
    color: "primary.main",
    width: "100%",
    maxHeight: "40.78px",
    p: 1.3,
    minWidth: 0,
  },
});
